import { IInventoryScanOption } from '../../../../types';
import { createZustandStore } from '../../../../zustand';

import { IInboundNDRStoreState } from './type';

const DEFAULT_SCAN_TYPE: IInventoryScanOption = {
  key: 'BAR_CODE',
  value: {
    ar: 'باركود',
    en: 'Bar Code',
  },
};

/**
 * This creates a local global state for NDR inbound data management.
 */
export const useNDRStore = createZustandStore<IInboundNDRStoreState>()(
  (set) => ({
    assetDetails: null,
    updateAssetDetails: (data) => set({ assetDetails: data }),
    currentScanStep: 'scanPackage',
    updateCurrentScanStep: (currentScanStep) =>
      set(() => ({ currentScanStep })),
    isScannerReadingData: false,
    updateIsScannerReadingData: (isScannerReadingData) =>
      set(() => ({ isScannerReadingData })),
    packageIdentifier: '',
    scanType: DEFAULT_SCAN_TYPE,
    updateScanType: (scanType) => set(() => ({ scanType })),
    scannedAssetDetails: null,
    updateScannedAssetDetails: (data) =>
      set(() => ({ scannedAssetDetails: data })),
    resetStore: () =>
      set(() => ({
        assetDetails: null,
        currentScanStep: 'scanPackage',
        isScannerReadingData: false,
        packageIdentifier: '',
        scanType: DEFAULT_SCAN_TYPE,
        scannedAssetDetails: null,
        pendingNdrPackagesCount: 0,
      })),
    pendingNdrPackagesCount: 0,
    updatePendingNdrPackagesCount: (count) =>
      set(() => ({ pendingNdrPackagesCount: count })),
  })
);
